import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination'; // Pagination
import { Ng2OrderModule } from 'ng2-order-pipe'; // importing the module
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LeftnavComponent } from './components/sidenav/leftnav.component';
import { TopnavComponent } from './components/topnav/topnav.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { OrderModule } from 'ngx-order-pipe';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

import {
  BusinessesComponent
} from './features/admin/businesses/businesses.component';
import {
  YourCustomersComponent
} from './features/provider/your-customers/your-customers.component';
import { CustomerLocationsComponent } from './features/provider/customer-locations/customer-locations.component';
import {
  CustomerPondsComponent
} from './features/provider/customer-ponds/customer-ponds.component';
import { PersonsListComponent } from './features/admin/persons/persons-list.component';
import { CultureSummaryReportComponent } from './features/provider/culture-summary/culture-summary-report.component';
import { LoginComponent } from './components/login/login.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsofuseComponent } from './components/termsofuse/termsofuse.component';
import { PondsSummaryReportsComponent } from './features/provider/pond-summary/ponds-summary.component';
import { CurrencyFormatPipe } from './core/pipes/currency-format.pipe';
import { AclSyncComponent } from './features/admin/acl-sync/acl-sync.component';
import { SpeciesTypeComponent } from './features/admin/species-types/species-type.component';
import { CultureCategoryComponent } from './features/admin/culture-categories/culture-category.component';
import { SoilTypeComponent } from './features/admin/soil-types/soil-type.component';
import { WaterTypeComponent } from './features/admin/water-types/water-type.component';
import { BarCodeComponent } from './features/provider/barcodes/bar-code.component';
import { UnitsOfMeasuresComponent } from './features/admin/units-of-measures/uom.component';
import { WaterQualityHistoryComponent } from './features/provider/water-quality-history/water-quality-history.component';
import { ItemTypesComponent } from './features/admin/item-types/item-types.component';
import { TransactionTypeComponent } from './features/admin/transaction-types/transaction-type.component';
import { FeedComponent } from 'src/app/features/provider/feed-metrics/feed.component';
import { StockingDensityComponent } from './features/provider/stocking-density-metrics/stocking-density.component';
import { PondComponent } from './features/provider/pond-metrics/pond.component';
import { WaterQualityComponent } from './features/provider/water-quality-metrics/water-quality.component';
import { GrowthComponent } from './features/provider/sampling-metrics/growth.component';
import { HarvestComponent } from './features/provider/harvest-metrics/harvest.component';
import { RoutesComponent } from './features/admin/routes/routes.component';
import { FeatureComponent } from './features/admin/features/feature.component';
import { ScreenComponent } from './features/admin/screens/screen.component';
import { ToastNoAnimationModule, ToastrModule } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AsyncPipe, DatePipe } from '@angular/common';
import { PondTracebilityComponent } from './features/provider/traceability-summary/pond-tracebility.component';
import { DaySummaryComponent } from './features/provider/day-summary/day-summary.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { BusinessCategoryComponent } from './features/admin/business-categories/business-category.component';
import { PersonRoleComponent } from './features/admin/person-roles/person-role.component';
import { BusinessTypeComponent } from './features/admin/business-types/business-type.component';
import { ProductsComponent } from './features/provider/products/products.component';
import { ShapesComponent } from './features/admin/shapes/shapes.component';
import { ActivityTrackerComponent } from './features/provider/activity-tracker/activity-tracker.component';
import { ExcelService } from './core/services/excel.service';
import { GoogleMapsModule } from '@angular/google-maps';
import { OrdersComponent } from './features/provider/product-orders/orders.component';
import { HomeComponent } from './components/home/home.component';
import { ForgotPasswordStep1Component } from './components/forgot-password-step1/forgot-password-step1.component';
import { ForgotPasswordStep2Component } from './components/forgot-password-step2/forgot-password-step2.component';
import { ResetpasswordComponent } from './components/resetpassword/resetpassword.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { QuickRegistrationComponent } from './features/admin/quick-registration/quick-registration.component';
import { CustomerAccountClosureComponent } from './features/provider/customer-account-closure/customer-account-closure.component';
import { AccountClosureComponent } from './features/admin/account-closure/account-closure.component';
import { FirebaseNotificationsMessagingService } from './core/services/firebase-messaging.service';
import { initializeApp } from "firebase/app";
import { PreviousRouteService } from './core/services/previous-route.service';
import { VisitsComponent } from './features/provider/visits/visits.component';
import { DateRangePopupComponent } from './features/provider/date-range-popup/date-range-popup.component';
import { ProviderDashboardComponent } from './features/provider/provider-dashboard/provider-dashboard.component';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatNativeDateModule, MatOptionModule } from "@angular/material/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatRadioModule } from '@angular/material/radio';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CUSTOM_DATE_FORMATS } from './core/utilities/date-format';
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AdminDashboardComponent } from './features/admin/admin-dashboard/admin-dashboard.component';
import { ActivitiesListComponent } from './features/admin/activities/activities-list.component';
import { BroodBreedersComponent } from './features/admin/brood-breeders/brood-breeders.component';
import { BroodLinesComponent } from './features/admin/brood-lines/brood-lines.component';
import { ObservationTypesComponent } from './features/admin/observation-types/observation-types.component';
import { TreatmentTypesComponent } from './features/admin/treatment-types/treatment-types.component';
import { PondTypesComponent } from './features/admin/pond-types/pond-types.component';
import { PondUsagesComponent } from './features/admin/pond-usages/pond-usages.component';
import { TimeFormatPipe } from './core/pipes/time-format.pipe';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { BusinessProfileComponent } from './features/provider/business-profile/business-profile.component';

initializeApp(environment.firebase);

/**
 * @module AppModule
 * @description
 * The root module of the AquaCloud application. It serves as the central hub for declaring components,
 * importing modules, and providing global services.
 *
 * **Key Responsibilities:**
 * 1. **Application Bootstrap**: Bootstraps the `AppComponent` to launch the application.
 * 2. **Component Declaration**: Registers all application components, including:
 *    - **Admin Panel**: User access, trading community, hardware configuration.
 *    - **Dashboards**: Main dashboard, SME dashboard, provider dashboards.
 *    - **Reports**: Farm summary, water quality, weekly growth, activity trackers.
 *    - **Material Management**: Transactions, batch management, vendor masters.
 * 3. **Module Integration**: Imports core Angular modules and third-party libraries:
 *    - **UI Frameworks**: Angular Material and ngx-bootstrap.
 *    - **Utilities**: Toastr for notifications, Pagination, Ordering.
 *    - **Maps**: Google Maps integration.
 * 4. **Global Configuration**:
 *    - Configures `ToastrModule` with global settings (timeout, progress bar).
 *    - Configures `BsDatepickerModule`.
 *    - Sets up Material Datepicker with Moment.js adapter and custom formats.
 *
 * **Global Services (Providers):**
 * - `FirebaseNotificationsMessagingService`: Manages push notifications.
 * - `ExcelService`: Handles Excel export functionality.
 * - `PreviousRouteService`: Tracks navigation history.
 * - `DatePipe`, `AsyncPipe`: Global pipes.
 *
 * **Initialization Logic:**
 * - Initializes Firebase app with environment configuration.
 * - Dynamically loads Google Maps API script in the constructor.
 *
 * @author AquaCloud Development Team
 * @version 1.0.0
 */
@NgModule({
  declarations: [
    AppComponent,
    LeftnavComponent,
    TopnavComponent,
    PondComponent,
    FeedComponent,
    StockingDensityComponent,
    HarvestComponent,
    GrowthComponent,
    WaterQualityComponent,
    BusinessesComponent,
    BusinessProfileComponent,
    YourCustomersComponent,
    CustomerLocationsComponent,
    CustomerPondsComponent,
    PersonsListComponent,
    CultureSummaryReportComponent,
    LoginComponent,
    PrivacyPolicyComponent,
    TermsofuseComponent,
    PondsSummaryReportsComponent,
    CurrencyFormatPipe,
    AclSyncComponent,
    SpeciesTypeComponent,
    CultureCategoryComponent,
    SoilTypeComponent,
    WaterTypeComponent,
    BarCodeComponent,
    WaterQualityHistoryComponent,
    UnitsOfMeasuresComponent,
    ItemTypesComponent,
    TransactionTypeComponent,
    RoutesComponent,
    FeatureComponent,
    ScreenComponent,
    PondTracebilityComponent,
    DaySummaryComponent,
    BusinessCategoryComponent,
    PersonRoleComponent,
    BusinessTypeComponent,
    ProductsComponent,
    ShapesComponent,
    ActivityTrackerComponent,
    OrdersComponent,
    HomeComponent,
    ForgotPasswordStep1Component,
    ForgotPasswordStep2Component,
    ResetpasswordComponent,
    QuickRegistrationComponent,
    AccountClosureComponent,
    CustomerAccountClosureComponent,
    VisitsComponent,
    DateRangePopupComponent,
    ProviderDashboardComponent,
    AdminDashboardComponent,
    ActivitiesListComponent,
    BroodBreedersComponent,
    BroodLinesComponent,
    ObservationTypesComponent,
    TreatmentTypesComponent,
    PondTypesComponent,
    PondUsagesComponent,
    TimeFormatPipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxPaginationModule,
    // Ng2OrderModule,
    Ng2OrderModule,
    AutocompleteLibModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    OrderModule,
    ReactiveFormsModule,
    CollapseModule,
    BsDropdownModule,
    TimepickerModule,
    ButtonsModule,
    // IvyCarouselModule
    // AngularDateTimePickerModule
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 2000, // 1 seconds
      progressBar: true,
    }), // ToastrModule added,
    ToastNoAnimationModule.forRoot(),
    GoogleMapsModule,
    NgxMaterialTimepickerModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatSlideToggleModule,
    ScrollingModule
  ],
  providers: [FirebaseNotificationsMessagingService, AsyncPipe, ExcelService, PreviousRouteService, DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  /**
   * @constructor
   * @description
   * Initializes the AppModule.
   * Triggers the loading of external scripts required for the application.
   */
  constructor() {
    this.loadGoogleMaps();
  }

  /**
   * @method loadGoogleMaps
   * @description
   * Dynamically appends the Google Maps JavaScript API script to the document head.
   * This is necessary for the `GoogleMapsModule` and related components (e.g., `MapDeviceComponent`) to function.
   *
   * **Implementation Details:**
   * - Creates a `<script>` element.
   * - Sets the `src` attribute with the API key.
   * - Sets `async` and `defer` for performance.
   * - Appends to `document.head`.
   *
   * @returns {void}
   * @side-effect Modifies the DOM by adding a script tag.
   */
  loadGoogleMaps() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
}
